// First Letter
const firstLetter = {
  id: 1,
  dateArchived: '2024-04-12',
  title: 'First Letter',
  isNew: false,
  letterContent: {
    text: `My sweet girl, I'm so proud of you. I'm so grateful for you. I'm so lucky that I have you. I'm so in love with you.`,
    image: '/pictures/IMG_7870.jpeg',
    greeting: 'My Dearest Reegan,',
    closing: 'With all my love,',
    signature: 'Alex'
  }
};

export default firstLetter;
